<template>
  <b-modal
    body-class="modal-wrapper-body"
    footer-class="modal-wrapper-footer"
    header-class="modal-wrapper-header"
    :content-class="contentClass"
    :hide-header="hideHeader"
    :dialog-class="dialogClass"
    :id="modalId"
    centered
    :hide-footer="hideFooter"
    :scrollable="scrollable"
    @hide="$emit('hide')"
  >
    <template #modal-header="{}">
      <subtitle>{{ title }}</subtitle>
      <button v-if="withCrossButton" class="news-close-button" @click="$emit('onCancelClick')" />
    </template>

    <slot></slot>

    <template #modal-footer="{ cancel }">
      <main-button class="news-footer-button" @click="$emit('onSaveClick')"> Сохранить </main-button>
      <main-button
        color="link"
        class="news-footer-button"
        @click="
          $emit('onCancelClick');
          cancel();
        "
        >Отмена</main-button
      >
    </template>
  </b-modal>
</template>

<script>
import Subtitle from "../ui/Subtitle.vue";
import MainButton from "../ui/MainButton.vue";
export default {
  components: { Subtitle, MainButton },
  props: {
    modalId: {
      type: String,
      require: true,
    },
    title: {
      type: String,
      require: false,
    },
    hideFooter: {
      type: Boolean,
      require: false,
    },
    hideHeader: {
      type: Boolean,
      require: false,
    },
    scrollable: {
      type: Boolean,
      require: false,
    },
    dialogClass: {
      type: String,
      require: false,
    },
    contentClass: {
      type: String,
      require: false,
    },
    withCrossButton: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
};
</script>

<style>
.modal-wrapper-header {
  border: none;
  padding: 24px 24px 32px;
}

.modal-wrapper-footer {
  background-color: var(--background-color);
  padding: 16px 24px;
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  border: 0;
}

.modal-wrapper-body {
  padding: 0;
}
</style>
